module.exports = __webpack_public_path__ + "img/docRes_c.f88da028.png";